import React, { useEffect, useState } from 'react'

//form
import {useForm} from "react-hook-form"
import * as yup from "yup"
import {yupResolver} from "@hookform/resolvers/yup"

//firebase
import { dataBase } from "../utils/FirebaseConfig"
import {createUserWithEmailAndPassword} from "firebase/auth"

//api
import axios from "../utils/axios"

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye,faEyeSlash,faXmark } from '@fortawesome/free-solid-svg-icons';
   

export const Register = () => {

    const [show, setShow] = useState(false)

    const [showIcon, setShowIcon] = useState(false)

    const [verify, setVerify] = useState('Not verify')

    const [Otp, setOtp] = useState([])

    const [userOTP, setUserOTP] = useState([])

    const [second, setSecond] = useState(60)
  
    const schema = yup.object().shape({
      name:yup.string().required(),
      email:yup.string().email().required(),
      password:yup.string().min(7).max(20).required(),
      confirm_password: yup.string().label('confirm password').required().oneOf([yup.ref('password'), null], 'Passwords must match'),
     })
  
    const {register, handleSubmit, reset, formState: { errors }} = useForm({
      resolver: yupResolver(schema)
    });
  
    const onSubmit = async(data,e)=>{
  
      //this is used to prevent a loading page  
      e.preventDefault();
      let password = data.password;
      // console.log(password)
  
      try {
          if(Otp === userOTP){
            if( password.match(/[!@#$%^&*]/) != null && password.match(/.{8,}/) != null &&  password.match(/[0-9]/) != null && password.match(/[A-Z]/) != null ){

              //This is a firebase method to create a new user
              await createUserWithEmailAndPassword(dataBase,data.email,data.password)
                  .then(async()=>{
                    await axios.post("/signup",
                        //passing the data to frontend using post 
                        {   
                            Name:data.name,
                            Email:data.email,
                            //Phone:data.phone,
                            Pass:data.password,
                        },
                        {
                          headers:{"Content-Type": "application/json"},
                          withCredentials:true,
                        }
                    ).then(res=>{ 
                      setShow(!show)
                        setTimeout(()=>{
                          //this is used to redirect to login after the registered in successfully
                          // window.location.href="/login"
                          window.location.href="/login"
                        },2000)

                        const user = dataBase.currentUser;
                        console.log(user)
                        toast.success("User Registered Succesfully",{ position:"top-right" })
                        console.log(res)
                    }).catch(err => 
                      console.log(err.message)
                    ) 
                  }).catch( err =>{ 
                      //if err message match this value its retrun toast
                      if(err.message.match("email-already-in-use")){
                    
                        toast.error("Email already used",{ position:"top-right" })
                      }
                      // toast.error("Email is already used",{ position:"top-right" })
                      console.log(err.message) 
                  })
            } else{
                console.log("invalid password")
                toast.error(<div>Password must be:<br/> 1) Between 8-30 characters,<br/> 2) At least one upper and lower case letter,<br/> 3) At least one number,<br/> 4) At least one special character</div>,{position:"top-right"})
            }
          }else{
              toast.error("Please enter valid otp",{position:"top-right"})
          }
      } catch (error) {
           console.log(error.message)
           toast.error(error.message,{ position:"top-right" })
      }
    }

    const handlSshowHide =()=>{
        setShowIcon(!showIcon)
    }

    const handleClick = async(data,e) =>{
	let password = data.password;
        e.preventDefault()
      try {
	 if( password.match(/[!@#$%^&*]/) != null && password.match(/.{8,}/) != null &&  password.match(/[0-9]/) != null && password.match(/[A-Z]/) != null ){

          await axios.put("/signup/otp",
            {
              email:data.email,
              Name:data.name,
              command: 'stop'
            },
            {
                headers:{"Content-Type": "application/json"},
              withCredentials:true,
            },
          ).then((res)=>{
              const otp = res?.data.otp
              // console.log(otp)
              setOtp(otp)
              setVerify("hi")
              setSecond(60)
              toast.success(<div>OTP has been sent to your email.<br/> Please verify the otp</div>,{enableHtml: true,position:'top-right'})
          }).catch(err => toast.error("Email already used",{ position:"top-right" }))
	 } else{
                console.log("invalid password")
                toast.error(<div>Password must be:<br/> 1) Between 8-30 characters,<br/> 2) At least one upper and lower case letter,<br/> 3) At least one number,<br/> 4) At least one special character</div>,{position:"top-right"})
         }      
	} catch (error) {

          console.log(error)
      }
      }

  return (
    <div>
      {
        verify === 'Not verify' ? (
            <>
              <form className="auth-form" >
                  <div className="mb-3 form-group" >
                  {/* <div  > */}
                      <i className="iconsax" data-icon="user-1"></i>
                      <label htmlFor="name" className="form-label">Name</label>
                      <input {...register("name")} type="name"  placeholder="Enter your name" className="form-control" id="name"/>
                      {errors.name && <p style={{fontSize:'12px',color:'red'}}>Name must match</p>}
                  </div>
                  <div className="mb-3 form-group">
                  {/* <div  > */}
                      <i className="iconsax" data-icon="mail"></i>
                      <label htmlFor="emailid" className="form-label">Email ID</label>
                      <input {...register("email")} type="email" placeholder="Enter your mail id" className="form-control" id="emailid"/>
                      {errors.email && <p style={{fontSize:'12px',color:'red'}}>Email must match</p>}
                  </div>
                  <div className="mb-3 form-group pos-rel">
                  {/* <div  > */}
                      <i className="iconsax" data-icon="lock-2"></i>
                      <label htmlFor="password" className="form-label">Password</label>
                      <input {...register("password")} placeholder="Enter your password" type={showIcon ? "text" : "password"} className="form-control" id="password"/>
                      {errors.password && <p style={{fontSize:'12px',color:'red'}}>Password has to be between 8-30 characters, and contains at least one uppercase letter, one lowercase letter and a number</p>}
                      {/* <span className="eye"><i className="fa-regular fa-eye-slash"></i></span> */}
                      <div className='log-icon'>
                        <FontAwesomeIcon icon={faXmark} onClick={()=>{reset({password:""})}} />
                        {
                            showIcon ? (
                                <FontAwesomeIcon icon={faEye}  id='show_hide' onClick={handlSshowHide}  />
                            ) : (
                                <FontAwesomeIcon icon={faEyeSlash}  id='show_hide' onClick={handlSshowHide}  />
                            )
                        }
                      </div>
                  </div>
                  <div className="mb-3 form-group pos-rel">
                  {/* <div  > */}
                      <i className="iconsax" data-icon="lock-2"></i>
                      <label htmlFor="password1" className="form-label">Confirm Password</label>
                      <input {...register("confirm_password")} placeholder="Enter your password" type="password" className="form-control" id="password1"/>
                      <div className='log-icon'>
                        <FontAwesomeIcon icon={faXmark} onClick={()=>{reset({confirm_password:""})}} />
                      </div>
                      {errors.confirm_password && <p style={{fontSize:'12px',color:'red'}}>Confirm Password must match with Password</p>}
                  </div>
                  <button data-cursor="pointer" onClick={(handleSubmit(handleClick))} className="btn-solid w-100 text-center mt-4">
                      Sign up
                  </button>
                  <h4 className="text-title text-center mt-2">Already have an account 
                    <a data-cursor="pointer" href style={{cursor:"pointer"}} onClick={()=>document.getElementById('login-tab').click()}>Sign in</a>
                  </h4>
              </form>
            </> 
          ):(
            <>
              <ChildComponent second={second} setSecond={setSecond} userOTP={userOTP} setUserOTP={setUserOTP} handleOTP={handleSubmit(handleClick)} onSubmit={handleSubmit(onSubmit)} />
            </>
          )
      }
        {/* <ChildComponent /> */}
    </div>
  )
}


const ChildComponent = ({ second, setSecond, userOTP, setUserOTP, handleOTP, onSubmit }) => {

    useEffect(()=>{
        const interval = setInterval(()=>{
          
          if(second > 0 ){
            setSecond( second - 1)
          }
    
          if(second === 0){
            clearInterval(interval)
          }
        },1000)
    
        return ()=>{
          clearInterval(interval)
        }
        // eslint-disable-next-line
      },[second])
    return (
      <>
        <input type='number'  value={userOTP}   onChange={e=>setUserOTP(e.target.value)} required  className="form-control" id="exampleFormControlInput1" placeholder="Enter OTP "/>
        {
            second > 0 ? (
                <p>Time Remaining: {second < 10 ? `0${second}`: second} Secs</p>
            ) : (
                <p>Didn't receive the OTP?
                    {
                        second === 0 ? (
                            <button  className="log-btn" onClick={handleOTP}>Resend OTP</button>

                        ) : (
                            <p>Resend OTP</p>
                        )
                    }
                </p>
            )
        }
        <button onClick={onSubmit} data-size="large" type="button" className="jRLsY SOUdU" style={{"width": "100%", "marginTop": "24px"}}> Submit </button>
      </>
    );
};
